import {
  GET_SKIN_CONCERNS,
  GET_SKIN_CONCERNS_SUCCESS,
  GET_SKIN_CONCERNS_FAILURE,
} from './action';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const getSkinConcernsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SKIN_CONCERNS:
      return { ...state, loading: true };
    case GET_SKIN_CONCERNS_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_SKIN_CONCERNS_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default getSkinConcernsReducer;
